import Axios from 'axios'

export interface GitiumRequestConfig {
  centerUrl: string
  unCenterUrl: string
  timeout: number
}

export interface Response {
  data: any
  status: string
  msg: string
}

export interface GitiumRequestObject {
  UN_POST: GitiumRequest
  POST: GitiumRequest
}

export interface GitiumRequest {
  (url: string, pramas?: any): Promise<Response>
}

const CONTENT_TYPE = 'application/json'

export default function GitiumRequest(config: GitiumRequestConfig): GitiumRequestObject {
  let uncenterAxiosInstance = Axios.create({
    baseURL: config.unCenterUrl,
    timeout: config.timeout,
    headers: {
      post: {
        'X-IOTA-API-Version': '1',
        'content-type': CONTENT_TYPE
      }
    }
  })

  let centerAxiosInstance = Axios.create({
    baseURL: config.centerUrl,
    timeout: config.timeout,
    headers: {
      post: {
        'content-type': CONTENT_TYPE
      }
    }
  })

  centerAxiosInstance.interceptors.response.use(
    value => value.data,
    error => {
      throw error
    }
  )

  const UN_POST: GitiumRequest = (url, params) => uncenterAxiosInstance.post(url, params)
  const POST: GitiumRequest = (url, params) => centerAxiosInstance.post(url, params)

  return {
    UN_POST,
    POST
  }
}
